var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.66406C9.87827 2.66406 7.84344 3.50692 6.34315 5.00721C4.84285 6.5075 4 8.54233 4 10.6641C4 16.0641 11.05 22.1641 11.35 22.4241C11.5311 22.579 11.7616 22.6641 12 22.6641C12.2384 22.6641 12.4689 22.579 12.65 22.4241C13 22.1641 20 16.0641 20 10.6641C20 8.54233 19.1571 6.5075 17.6569 5.00721C16.1566 3.50692 14.1217 2.66406 12 2.66406ZM12 20.3141C9.87 18.3141 6 14.0041 6 10.6641C6 9.07276 6.63214 7.54664 7.75736 6.42142C8.88258 5.2962 10.4087 4.66406 12 4.66406C13.5913 4.66406 15.1174 5.2962 16.2426 6.42142C17.3679 7.54664 18 9.07276 18 10.6641C18 14.0041 14.13 18.3241 12 20.3141ZM12 6.66406C11.2089 6.66406 10.4355 6.89866 9.77772 7.33818C9.11992 7.77771 8.60723 8.40242 8.30448 9.13333C8.00173 9.86423 7.92252 10.6685 8.07686 11.4444C8.2312 12.2203 8.61216 12.9331 9.17157 13.4925C9.73098 14.0519 10.4437 14.4329 11.2196 14.5872C11.9956 14.7415 12.7998 14.6623 13.5307 14.3596C14.2616 14.0568 14.8864 13.5441 15.3259 12.8863C15.7654 12.2285 16 11.4552 16 10.6641C16 9.6032 15.5786 8.58578 14.8284 7.83564C14.0783 7.08549 13.0609 6.66406 12 6.66406ZM12 12.6641C11.6044 12.6641 11.2178 12.5468 10.8889 12.327C10.56 12.1072 10.3036 11.7949 10.1522 11.4294C10.0009 11.064 9.96126 10.6618 10.0384 10.2739C10.1156 9.88592 10.3061 9.52955 10.5858 9.24985C10.8655 8.97014 11.2219 8.77966 11.6098 8.70249C11.9978 8.62532 12.3999 8.66493 12.7654 8.8163C13.1308 8.96768 13.4432 9.22402 13.6629 9.55292C13.8827 9.88182 14 10.2685 14 10.6641C14 11.1945 13.7893 11.7032 13.4142 12.0783C13.0391 12.4533 12.5304 12.6641 12 12.6641Z",
    fill: "url(#paint0_linear_432_2476)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_432_2476",
    x1: 12,
    y1: 2.66406,
    x2: 12,
    y2: 22.6641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4F1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDirection);
export default __webpack_public_path__ + "static/media/IconDirection.f2b024305ff1260dd0a39723123f6b27.svg";
export { ForwardRef as ReactComponent };